/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUltimateBeneficialOwnerOutput
 */
export interface UpdateUltimateBeneficialOwnerOutput {
    /**
     * 
     * @type {number}
     * @memberof UpdateUltimateBeneficialOwnerOutput
     */
    ultimateBeneficialOwnerId?: number;
    /**
     * 
     * @type {Error}
     * @memberof UpdateUltimateBeneficialOwnerOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the UpdateUltimateBeneficialOwnerOutput interface.
 */
export function instanceOfUpdateUltimateBeneficialOwnerOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateUltimateBeneficialOwnerOutputFromJSON(json: any): UpdateUltimateBeneficialOwnerOutput {
    return UpdateUltimateBeneficialOwnerOutputFromJSONTyped(json, false);
}

export function UpdateUltimateBeneficialOwnerOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUltimateBeneficialOwnerOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ultimateBeneficialOwnerId': !exists(json, 'ultimateBeneficialOwnerId') ? undefined : json['ultimateBeneficialOwnerId'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function UpdateUltimateBeneficialOwnerOutputToJSON(value?: UpdateUltimateBeneficialOwnerOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ultimateBeneficialOwnerId': value.ultimateBeneficialOwnerId,
        'error': value.error,
    };
}

